import { createZodDto } from "nestjs-zod/dto";
import { z } from "zod";

export const storeByokKeySchema = z.object({
  apiKey: z.string().min(1).startsWith("sk-"),
});

export class StoreByokKeyDto extends createZodDto(storeByokKeySchema) {}

export const byokStatusSchema = z.object({
  exists: z.boolean(),
});

export type ByokStatusDto = z.infer<typeof byokStatusSchema>;
